import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "banniere",
  role: "alert"
}
const _hoisted_2 = { class: "icon-container" }
const _hoisted_3 = ["alt", "src"]
const _hoisted_4 = { class: "banniere-content" }
const _hoisted_5 = { class: "banniere-titre" }
const _hoisted_6 = { class: "banniere-message" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        alt: _ctx.$t('accessDenied.iconAlt'),
        src: _ctx.loadCross,
        class: "icon-warning"
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.resolvedTitle), 1),
      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.resolvedMessage), 1),
      (_ctx.homePath)
        ? (_openBlock(), _createBlock(_component_RouterLink, {
            key: 0,
            to: _ctx.homePath,
            class: "banniere-button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.resolvedHomeText), 1)
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true)
    ])
  ]))
}